import { render } from "./attractCard.vue?vue&type=template&id=20c76777&scoped=true"
const script = {}

import "./attractCard.vue?vue&type=style&index=0&id=20c76777&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c76777"]])

export default __exports__